/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Finalizes_CaseInputs */

const en_task_flow_finalizes_case = /** @type {(inputs: Task_Flow_Finalizes_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizes the case`)
};

const pt_br2_task_flow_finalizes_case = /** @type {(inputs: Task_Flow_Finalizes_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finaliza o caso`)
};

/**
* | output |
* | --- |
* | "Finalizes the case" |
*
* @param {Task_Flow_Finalizes_CaseInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_finalizes_case = /** @type {((inputs?: Task_Flow_Finalizes_CaseInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Finalizes_CaseInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_finalizes_case(inputs)
	return pt_br2_task_flow_finalizes_case(inputs)
});